import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "contract-detail-monitor"
};
const _hoisted_2 = {
  class: "contract-list-btn"
};
import { computed, onMounted, reactive, ref } from "vue";
import { Edit, Search } from '@element-plus/icons-vue';
import apis from "@/api";
import { ElMessage, ElMessageBox } from "element-plus";
import MonitorStatus from './MonitorStatus';
import AdvertLaunchAdd from './AdvertLaunchAdd';
import AdvertLaunchInfo from './AdvertLaunchInfo';
import AdvertLaunchResult from './AdvertLaunchResult';
import AdvertLaunchResultMany from './AdvertLaunchManyMonitor';
import { getAdvertLaunchMonitorManyPage, getAdvertLaunchMonitorTaskManyPage } from "@/api/modules/advert";
export default {
  __name: 'AdvertLaunchTaskList',
  props: {
    roleFlag: {
      type: String,
      default: ""
    },
    roleId: {
      type: String,
      default: ""
    },
    advertLaunch: {
      type: Object
    }
  },
  setup(__props) {
    const viewVisible = computed(() => {
      if (props.roleFlag == '0') {
        return true;
      }
      return false;
    });
    const props = __props;
    const headerStyle = ref({
      background: '#FAFAFA'
    });
    const data = reactive({
      queryParam: {},
      tableData: [],
      pagination: {
        totalSize: 0,
        pageSize: 10,
        pageNo: 1
      },
      // ,
      // areaSelect: [],
      currentAdertLaunch: {}
    });
    const advertLaunchAddVisible = ref(false);
    const advertLaunchDetailVisible = ref(false);
    const advertLaunchDetailTitle = ref("");
    const currentAction = ref('');
    const advertLaunchResultVisible = ref(false);
    const advertLaunchResultTitle = ref('');
    const elLoading = ref(false);
    const loadData = () => {
      const params = {
        id: props.advertLaunch.id,
        ...data.queryParam,
        ...data.pagination
      };
      elLoading.value = true;
      apis.getAdvertLaunchMonitorManyPage(params).then(res => {
        if (res.success) {
          const {
            records,
            size,
            total,
            current
          } = res.data;
          data.tableData = records;
          data.pagination = {
            totalSize: total,
            pageSize: size,
            pageNo: current
          };
        } else {
          ElMessage.error(res.msg);
        }
      }).catch(err => {
        ElMessage.error(err);
      }).finally(() => {
        elLoading.value = false;
      });
    };
    const handleSizeChange = val => {
      data.pagination.pageSize = val;
      loadData();
    };
    const handleCurrentChange = val => {
      data.pagination.pageNo = val;
      loadData();
    };

    //查看投放任务
    const handleView = row => {
      data.currentAdertLaunch = row;
      currentAction.value = 'detailView';
      advertLaunchDetailTitle.value = "投放任务明细";
      advertLaunchDetailVisible.value = true;
    };

    //去比对
    const handleMonitor = row => {
      data.currentAdertLaunch = row;
      currentAction.value = 'detailMonitor';
      advertLaunchDetailTitle.value = "比对投放任务明细";
      advertLaunchDetailVisible.value = true;
    };

    //查看比对结果
    const handleCompareResultView = row => {
      if (row.monitorState == 13) {
        ElMessage.info("任务待比对,稍后再来看看吧!");
        return;
      }
      if (row.monitorState == 6) {
        ElMessage.info("任务正在比对中,比对完成再来看看吧!");
        return;
      }
      data.currentAdertLaunch = row;
      currentAction.value = 'compareResult';
      advertLaunchResultVisible.value = true;
      advertLaunchResultTitle.value = "比对结果";
    };

    //复核比对重择监测图片
    const handleCheckRecordCompare = row => {
      data.currentAdertLaunch = row;
      currentAction.value = 'checkRecordCompare';
      advertLaunchDetailTitle.value = "复核比对";
      advertLaunchDetailVisible.value = true;
    };

    //新增比对任务
    const handleAddMonitorTask = row => {
      for (const item of data.tableData) {
        if (item.monitorState !== 9) {
          ElMessage.error("有未结束的监测任务,不能新增比对任务!");
          return;
        }
      }
      elLoading.value = true;
      ElMessageBox.confirm('确定新增比对任务吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        apis.addMonitorManyTask(props.advertLaunch).then(res => {
          if (res.success) {
            ElMessage.success("新增成功");
          } else {
            ElMessage.error(res.msg);
          }
        }).catch(err => {
          ElMessage.error(err);
        }).finally(() => {
          elLoading.value = false;
          loadData();
        });
      }).catch(err => {}).finally(() => {
        elLoading.value = false;
      });
    };
    onMounted(() => {
      loadData();
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_1, [__props.roleFlag == '2' ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        style: {
          "margin-left": "10px"
        },
        type: "primary",
        onClick: handleAddMonitorTask
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode("新增比对任务", -1)]))]),
        _: 1
      })) : _createCommentVNode("", true)]), _createElementVNode("div", null, [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: data.tableData,
        style: {
          "width": "100%"
        },
        "header-cell-style": headerStyle.value,
        "empty-text": "",
        border: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "opCompany",
          label: "执行公司"
        }), _createVNode(_component_el_table_column, {
          prop: "opName",
          label: "执行人"
        }), _createVNode(_component_el_table_column, {
          prop: "contractCode",
          label: "合同编码"
        }), _createVNode(_component_el_table_column, {
          prop: "contractName",
          label: "合同名称"
        }), _createVNode(_component_el_table_column, {
          prop: "contractPerson",
          label: "合同指派人"
        }), _createVNode(_component_el_table_column, {
          prop: "createTime",
          label: "创建时间"
        }), _createVNode(_component_el_table_column, {
          prop: "monitorState",
          label: "监测状态"
        }, {
          default: _withCtx(scope => [_createVNode(_unref(MonitorStatus), {
            "monitor-state": scope.row.monitorState
          }, null, 8, ["monitor-state"])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "操作"
        }, {
          default: _withCtx(scope => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [_createVNode(_component_el_button, {
            link: "",
            type: "primary",
            size: "small",
            onClick: $event => handleView(scope.row)
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode("查看", -1)]))]),
            _: 1
          }, 8, ["onClick"])]), _createElementVNode("div", null, [__props.roleFlag == '2' && scope.row.monitorState == 2 ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            link: "",
            type: "primary",
            style: {
              "color": "red"
            },
            size: "small",
            onClick: $event => handleMonitor(scope.row)
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("去比对", -1)]))]),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true)]), _createElementVNode("div", null, [(__props.roleFlag == '0' || __props.roleFlag == '1' || __props.roleFlag == '2' || __props.roleFlag == '3') && (scope.row.monitorState == 0 || scope.row.monitorState == 6 || scope.row.monitorState == 10 || scope.row.monitorState == 13 || scope.row.monitorState == 9 || scope.row.monitorState == 12) ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            link: "",
            type: "primary",
            size: "small",
            onClick: $event => handleCompareResultView(scope.row)
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode("查看比对结果", -1)]))]),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true)]), _createElementVNode("div", null, [__props.roleFlag == '1' && scope.row.monitorState == 10 ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            link: "",
            type: "primary",
            style: {
              "color": "red"
            },
            size: "small",
            onClick: $event => handleCompareResultView(scope.row)
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode("审核复核比对任务", -1)]))]),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true)]), _createElementVNode("div", null, [__props.roleFlag == '2' && scope.row.monitorState == 11 ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            link: "",
            type: "primary",
            style: {
              "color": "red"
            },
            size: "small",
            onClick: $event => handleCheckRecordCompare(scope.row)
          }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode("去复核比对", -1)]))]),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true)])])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data", "header-cell-style"])), [[_directive_loading, elLoading.value]])]), _createElementVNode("div", null, [_createVNode(_component_el_pagination, {
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange,
        "page-sizes": [10, 20, 50, 100, 200],
        "page-size": data.pagination.pageSize,
        total: data.pagination.totalSize,
        currentPage: data.pagination.pageNo,
        "onUpdate:currentPage": _cache[0] || (_cache[0] = $event => data.pagination.pageNo = $event),
        layout: "total, prev, pager, next, sizes, jumper"
      }, null, 8, ["page-size", "total", "currentPage"])])]), _createVNode(_unref(AdvertLaunchInfo), {
        visible: advertLaunchDetailVisible.value,
        "onUpdate:visible": _cache[1] || (_cache[1] = $event => advertLaunchDetailVisible.value = $event),
        title: advertLaunchDetailTitle.value,
        "advert-launch": data.currentAdertLaunch,
        "role-id": __props.roleId,
        "role-flag": __props.roleFlag,
        "current-action": currentAction.value,
        onRefresh: loadData
      }, null, 8, ["visible", "title", "advert-launch", "role-id", "role-flag", "current-action"]), _createVNode(_unref(AdvertLaunchResult), {
        visible: advertLaunchResultVisible.value,
        "onUpdate:visible": _cache[2] || (_cache[2] = $event => advertLaunchResultVisible.value = $event),
        title: advertLaunchResultTitle.value,
        "role-id": __props.roleId,
        "role-flag": __props.roleFlag,
        "advert-launch": data.currentAdertLaunch,
        "current-action": currentAction.value,
        onTaskEnd: loadData
      }, null, 8, ["visible", "title", "role-id", "role-flag", "advert-launch", "current-action"])], 64);
    };
  }
};